/** bosPopInput 内部工具（仅组件使用） */

export function getDataKey(item = {}) {
  const modal = item.bosPopModal || {};
  return modal.dataKey || item.colname || item.value;
}

export function getDisplayKey(dataKey) {
  return `${dataKey}__DISPLAY`;
}

export function isPermissionConditions(val) {
  if (!Array.isArray(val) || !val.length) return false;
  return val.every((item) => {
    if (Array.isArray(item)) {
      return item.length && item.every((c) => c && typeof c === 'object' && c.colname);
    }
    return item && typeof item === 'object' && item.colname;
  });
}

/** 内部弹窗/StandList 使用的 OR 分组结构 [[{...}], [{...},{...}]] */
export function toPermissionGroups(conds) {
  if (!Array.isArray(conds) || !conds.length) return [];
  if (conds.every((g) => Array.isArray(g) && g.length && g[0] && g[0].colname)) {
    return _.cloneDeep(conds);
  }
  return conds.map((item) => (Array.isArray(item) ? _.cloneDeep(item) : [item]));
}

/**
 * 写入 formValue / 提交接口：
 * - 筛选条件（含单条）：保留为数组，如 [{...}] 或 [{...},{...}]
 * - 勾选行 id 条件：展开为对象 { colname: 'id', ... }
 */
export function normalizeConditionsForRequest(groups) {
  return toPermissionGroups(groups).map((group) => {
    if (group.length === 1 && group[0] && group[0].colname === 'id') {
      return group[0];
    }
    return group;
  });
}

export function formatDisplay(conditionsForCombine = []) {
  if (!conditionsForCombine.length) return '';
  if (conditionsForCombine.length > 1) {
    return conditionsForCombine.map(i => `(${i.label})`).join(' 或者 ');
  }
  return conditionsForCombine.map(i => i.label).join('');
}

export function normalizePermissionConditionGroup(group) {
  if (!Array.isArray(group)) return group;
  return group.map((item) => {
    const next = { ...item };
    if (item.conddesc) {
      next.conddesc = next.label;
    }
    if (item.exclude) {
      next.exclude = true;
    }
    return next;
  });
}

export function formatIdCondLabel(item = {}) {
  const name = item.label || item.conddesc || item.value || '';
  return item.exclude ? `不包含(${name})` : `含有(${name})`;
}

export function formatPermissionCondGroupLabel(group = []) {
  const getLabel = (sub) => sub.label || sub.conddesc || '';
  if (group.length === 1) {
    const item = group[0];
    if (item.colname === 'id') {
      return formatIdCondLabel(item);
    }
    const label = getLabel(item);
    if (item.exclude) {
      return `不包含 (${label})`;
    }
    return `(${label})`;
  }
  const inner = group.map((sub) => {
    if (sub.colname === 'id') {
      return `(${formatIdCondLabel(sub)})`;
    }
    return `(${getLabel(sub)})`;
  }).join(' 并且 ');
  if (group.some((item) => item.exclude)) {
    return `不包含 (${inner})`;
  }
  return inner;
}

export function preparePermissionConditionsForSave(groups) {
  if (!Array.isArray(groups)) return []
  return groups.map((group) => {
    const items = Array.isArray(group) ? group : [group]
    return items.map((item) => {
      const next = { ...item }
      if (next.colname === 'id') {
        delete next.display
        delete next.table
      }
      return next
    })
  })
}

export function combineConditions(permeConds) {
  return toPermissionGroups(permeConds)
    .filter((group) => group.length > 0)
    .map((group, index) => ({
      label: formatPermissionCondGroupLabel(group),
      isCheck: false,
      _index: index,
    }))
    .filter(condItem => condItem.label);
}

export function readPermissionConditions(formValue, dataKey) {
  const val = formValue && formValue[dataKey];
  if (isPermissionConditions(val)) {
    return toPermissionGroups(val);
  }
  // 兼容旧数据 __CONDS
  const legacy = formValue && formValue[`${dataKey}__CONDS`];
  if (isPermissionConditions(legacy)) {
    return toPermissionGroups(legacy);
  }
  return null;
}

export function buildPermissionConditionsFromIds(idsStr, labelsStr, exclude = false) {
  const ids = String(idsStr || '').split(',').filter(Boolean);
  const labels = String(labelsStr || '').split(',');
  return ids.map((id, index) => [{
    colname: 'id',
    label: labels[index] || id,
    value: id,
    ...(exclude ? { exclude: true } : {}),
  }]);
}

export function getDisplayFromConditions(formValue, dataKey) {
  const conds = readPermissionConditions(formValue, dataKey);
  if (!conds || !conds.length) return '';
  return formatDisplay(combineConditions(conds));
}
